<template>
  <div class="container-fluid">
<!--    <a href="/ressources/" class="dark-gray-link back-resources ms-lg-3"><i class="fa-light fa-arrow-left"  aria-hidden="true"></i>-->
<!--      {{ pageTitle }}</a>-->
  </div>
  <div class="container">

    <div class="no-result-hero row align-items-center justify-content-center">
      <div class="col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0">
        <img src="/_/images/anim-dossiers.gif?v=2" class="img-fluid" alt="">
      </div>
      <div class="col-12 col-lg-8">
        <h2 class="mb-4" v-html="copydeck?.articles?.listingNoResultsPageTitle?.fr ?? 'copydeck?.articles?.listingNoResultsPageTitle?.fr'"></h2>

        <span v-html="copydeck?.articles?.noResultsFoundContent?.fr ?? 'copydeck?.articles?.noResultsFoundContent?.fr'"></span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

let store    = useStore();
let copydeck = computed( () => store.state.copydeck );
</script>
